import { z } from 'zod';

/**
 * How subscriptions gate the product (N14) — the two words that decide what the
 * whole paywall means.
 *
 * - `duration` — any active entitlement unlocks everything; numeric limits come
 *   from the base settings, and the capability map is not consulted at all.
 * - `feature` — a member's tier is mapped through `billing.tierCapabilities`,
 *   with `billing.tierLimits` overriding a base limit per field.
 *
 * ## Why it is in contracts rather than only in the setting
 *
 * The mode reaches the member on an **authenticated** read, because the paywall
 * has to know whether to draw a comparison at all. It is emphatically **not** a
 * `memberVisible` setting: `/app-settings` is unauthenticated, and publishing
 * the commercial policy there would hand every anonymous reader the tier map.
 *
 * `billing.planMode`'s registry definition derives its enum from here, so the
 * value the api stores and the value it puts on the wire cannot drift.
 */
export const BILLING_PLAN_MODES = ['duration', 'feature'] as const;

export const BillingPlanModeSchema = z.enum(BILLING_PLAN_MODES);

export type BillingPlanMode = (typeof BILLING_PLAN_MODES)[number];
